import React from "react";
import { ToolNavigationItem } from "../../../models/navigation/ToolNavigationItem";
import { CallToActionToolLink } from "./CallToActionToolLink";
import { LanguageToolLink } from "./LanguageToolLink";
import { MarketToolLink } from "./MarketToolLink";
import { SearchToolLink } from "./SearchToolLink";
import { StockTickerToolLink } from "./StockTickerToolLink";
import { ToolLink } from "./ToolLink";

interface Props extends ToolNavigationItem {
  targetDevice: "mobile" | "desktop";
  showSeparator: boolean;
}

const getFontClass = (fontsize: string) =>
  [
    "text-brand-primary-20",
    "hover:text-brand-primary-80",
    fontsize === "mobile" ? "text-base" : "text-sm-base"
  ].join(" ");

export const ToolItem = (props: Props) => {
  let wrapperClass = "inline-flex justify-between items-center px-4";

  if (props.showSeparator) {
    wrapperClass += " border-l border-separator";
  }

  let content: JSX.Element | null;
  const fontClass = getFontClass(props.targetDevice);

  switch (props.type) {
    case "link":
      content = props.isCallToAction ? (
        <CallToActionToolLink {...props} targetDevice={props.targetDevice} />
      ) : (
        <ToolLink {...props} fontClass={fontClass} />
      );
      break;

    case "language":
      content = <LanguageToolLink {...props} fontClass={fontClass} />;
      break;

    case "market":
      content = <MarketToolLink {...props} fontClass={fontClass} />;
      break;

    case "search":
      content = <SearchToolLink {...props} fontClass={fontClass} />;
      break;

    case "stockticker":
      content = <StockTickerToolLink {...props} fontClass={fontClass} />;
      break;

    default:
      content = null;
      break;
  }

  if (!content) {
    return null;
  }

  return <span className={wrapperClass}>{content}</span>;
};
